export default __webpack_public_path__ + "static/media/liasse.32b5590e.png";